import { Routes, Route, Navigate } from "react-router-dom";

import InstructorLayout from "layouts/instructor";
import AuthLayout from "layouts/auth";
import RequireAuth from "components/RequireAuth";
import { authStorage } from "services/authStorage";
import ContactSupportPage from "views/support/ContactSupportPage";

const App = () => {
  return (
    <Routes>
      <Route path="support/contact" element={<ContactSupportPage />} />
      <Route path="auth/*" element={<AuthLayout />} />
      <Route
        path="instructor/*"
        element={<RequireAuth requiredGuard="instructor"><InstructorLayout /></RequireAuth>}
      />
      <Route path="admin/*" element={<Navigate to="/auth/instructor-sign-in" replace />} />
      <Route path="rtl/*" element={<Navigate to="/auth/instructor-sign-in" replace />} />
      <Route
        path="/"
        element={
          <Navigate
            to={authStorage.isAuthenticated("instructor") ? "/instructor/default" : "/auth/instructor-sign-in"}
            replace
          />
        }
      />
    </Routes>
  );
};

export default App;
